import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";

export default function Loader({ onDone }) {
  const [phase, setPhase] = useState("enter"); // enter → hold → exit → done

  useEffect(() => {
    // Logo fades in over 500ms, hold for 1500ms, then exit over 600ms
    const hold  = setTimeout(() => setPhase("exit"),  2300);
    const done  = setTimeout(() => { setPhase("done"); onDone?.(); }, 2900);
    return () => { clearTimeout(hold); clearTimeout(done); };
  }, [onDone]);

  if (phase === "done") return null;

  return (
    <div className={"loader" + (phase === "exit" ? " loader--exit" : "")}>
      <div className="loader-inner">
        <img src={logo} alt="OVARD Digital" className="loader-logo" />
        <p className="loader-tagline">Your Brand. Our Strategy. Unlimited Growth.</p>
        <span className="loader-line" />
      </div>
    </div>
  );
}
